module.exports = __webpack_public_path__ + "static/media/RequestCard.57a28737.svg";